import React from "react";
import PropTypes from "prop-types";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import { downloadKioskApp } from "api";

class AddKioskDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadInitiated: false,
      error: null
    };
  }

  handleDownload = async (os) => {
    const osDisplayName = os === "windows" ? "Windows" : "Mac";
    const fallbackFilename = os === "windows" ? "storycrafter-kiosk-windows.exe" : "storycrafter-kiosk-mac.dmg";

    // Set download initiated state and clear any previous errors
    this.setState({ downloadInitiated: true, error: null });

    try {
      const { response, error } = await downloadKioskApp(os);
      
      if (error) {
        console.error(`Error downloading ${osDisplayName} kiosk app:`, error);
        const errorMessage = error.message || error.toString() || "An unknown error occurred";
        this.setState({ error: errorMessage });
        return;
      }

      // Extract filename from Content-Disposition header
      // Format: attachment; filename="${key}"
      const contentDisposition = response.headers["content-disposition"] || response.headers["Content-Disposition"];
      const filename = contentDisposition?.match(/filename="?([^"]+)"?/)?.[1] || fallbackFilename;

      // Create blob URL and trigger download
      const blob = new Blob([response.data]);
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error(`Error downloading ${osDisplayName} kiosk app:`, error);
      const errorMessage = error.message || error.toString() || "An unknown error occurred";
      this.setState({ error: errorMessage });
    }
  };

  handleWindowsDownload = () => {
    this.handleDownload("windows");
  };

  handleMacDownload = () => {
    this.handleDownload("mac");
  };

  render() {
    const { open, onClose } = this.props;

    const actions = [
      <FlatButton
        label="CLOSE"
        onClick={onClose}
        primary
        style={{ marginRight: 8 }}
      />,
    ];

    const downloadButtonStyle = {
      flex: 1,
      backgroundColor: "#f5f5f5",
      border: "1px solid #e0e0e0",
      borderRadius: 4,
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 16,
      transition: "background-color 0.2s",
    };

    const logoContainerStyle = {
      width: "70%",
      paddingBottom: "70%",
      position: "relative",
      maxWidth: 150,
      maxHeight: 150,
      marginBottom: 16,
    };

    const logoInnerStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const handleMouseEnter = (e) => {
      e.currentTarget.style.backgroundColor = "#eeeeee";
    };

    const handleMouseLeave = (e) => {
      e.currentTarget.style.backgroundColor = "#f5f5f5";
    };

    return (
      <Dialog
        open={open}
        modal={false}
        title="Add a Kiosk"
        actions={actions}
        bodyStyle={{ paddingTop: 20, paddingBottom: 20 }}
        actionsContainerStyle={{
          borderTop: "1px solid #e0e0e0",
        }}
        onRequestClose={onClose}
        contentStyle={{ maxWidth: 425, width: "90%" }}
      >
        <div style={{ marginBottom: 24, lineHeight: 1.5 }}>
          Use Storycrafter Kiosk to present a project on your touchscreen interactive. Just download and install the application on your computer, and log in to your Storycrafter account.
        </div>
        <div style={{ display: "flex", gap: 16, marginBottom: 24 }}>
          <div
            onClick={this.handleWindowsDownload}
            style={downloadButtonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div style={logoContainerStyle}>
              <div
                style={{
                  ...logoInnerStyle,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gridTemplateRows: "1fr 1fr",
                  gap: 4,
                  padding: 4,
                }}
              >
                <div style={{ backgroundColor: "#0078D4", width: "100%", height: "100%" }}></div>
                <div style={{ backgroundColor: "#0078D4", width: "100%", height: "100%" }}></div>
                <div style={{ backgroundColor: "#0078D4", width: "100%", height: "100%" }}></div>
                <div style={{ backgroundColor: "#0078D4", width: "100%", height: "100%" }}></div>
              </div>
            </div>
            <span style={{ fontSize: 14, textAlign: "center" }}>Download the Windows app</span>
          </div>
          <div
            onClick={this.handleMacDownload}
            style={downloadButtonStyle}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div style={logoContainerStyle}>
              <div
                style={{
                  ...logoInnerStyle,
                  backgroundColor: "#000000",
                  borderRadius: "50%",
                  flexDirection: "column",
                }}
              >
                <span style={{ color: "white", fontSize: 14, fontWeight: "bold", lineHeight: 1.2 }}>mac</span>
                <span style={{ color: "white", fontSize: 40, fontWeight: "bold", lineHeight: 1.2 }}>OS</span>
              </div>
            </div>
            <span style={{ fontSize: 14, textAlign: "center" }}>Download the Mac OS installer</span>
          </div>
        </div>
        {this.state.downloadInitiated && !this.state.error && (
          <div style={{ marginTop: 16, padding: 12, backgroundColor: "#e3f2fd", borderRadius: 4, color: "#1976d2" }}>
            The kiosk app download has begun. Once downloaded, it will appear in your downloads folder. You can safely close this window.
          </div>
        )}
        {this.state.error && (
          <div style={{ marginTop: 16, padding: 12, backgroundColor: "#ffebee", borderRadius: 4, color: "#c62828" }}>
            <strong>Error downloading kiosk app:</strong> {this.state.error}
          </div>
        )}
      </Dialog>
    );
  }
}

AddKioskDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddKioskDialog;

